import type { CarOrderDetailDriverInfo } from "@/api/car";

function hasDriverInfo(d: CarOrderDetailDriverInfo | null | undefined): boolean {
  if (d == null) return false;
  return Boolean(
    (d.name && d.name.trim()) ||
      (d.phone && d.phone.trim()) ||
      (d.license_plate && d.license_plate.trim()),
  );
}

export default function CarLocationModal({
  onClose,
  driver,
}: {
  onClose: () => void;
  /** 租车订单详情中的派车司机；未传或非租车场景不展示司机卡片 */
  driver?: CarOrderDetailDriverInfo | null;
}) {
  const showDriver = hasDriverInfo(driver ?? undefined);
  const initial =
    driver?.name?.trim()?.[0] ?? (driver?.license_plate?.trim()?.[0] ?? "司");
  const tel = driver?.phone?.replace(/\s/g, "") ?? "";

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center"
      style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)" }}
    >
      <div className="bg-white rounded-t-3xl w-full" style={{ maxWidth: 480 }}>
        <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mt-3" />
        <div
          className="flex items-center justify-between px-5 pt-4 pb-3"
          style={{ borderBottom: "1px solid #F5F5F5" }}
        >
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer"
            style={{ background: "#F4F5F9" }}
          >
            <i
              className="ri-close-line"
              style={{ color: "#374151", fontSize: 18 }}
            />
          </button>
          <span className="text-base font-bold text-gray-900">车辆实时位置</span>
          <div className="w-8" />
        </div>
        <div className="px-5 py-5">
          <div className="rounded-2xl overflow-hidden mb-4" style={{ height: 220 }}>
            <img
              src="https://readdy.ai/api/search-image?query=aerial%20view%20city%20map%20road%20network%20top%20down%20navigation%20GPS%20tracking%20route%20planning%20map%20illustration%20modern%20clean%20style&width=400&height=220&seq=carloc01&orientation=landscape"
              alt="map"
              className="w-full h-full object-cover"
            />
            <div className="relative -mt-16 flex justify-center">
              <span
                className="px-3 py-1.5 rounded-full text-xs font-semibold text-white flex items-center gap-1.5"
                style={{ background: "rgba(37,99,235,0.92)" }}
              >
                <i className="ri-car-line" style={{ fontSize: 12 }} />
                车辆位置请在地图中查看
              </span>
            </div>
          </div>
          {showDriver && driver && (
            <div className="p-4 rounded-2xl mb-4" style={{ background: "#F0F4FF" }}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-semibold text-gray-700">派车司机</span>
                <span
                  className="text-xs px-2 py-0.5 rounded-full font-medium"
                  style={{ background: "#DCFCE7", color: "#16A34A" }}
                >
                  已派车
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-base flex-shrink-0"
                  style={{ background: "#2563EB" }}
                >
                  {initial}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-gray-900 truncate">
                    {driver.name?.trim() || "—"}
                  </div>
                  <div className="text-xs text-gray-400 space-y-0.5">
                    {driver.license_plate?.trim() ? (
                      <div>车牌 {driver.license_plate.trim()}</div>
                    ) : null}
                    {driver.phone?.trim() ? (
                      <div>电话 {driver.phone.trim()}</div>
                    ) : null}
                    {driver.remark?.trim() ? (
                      <div className="line-clamp-2">{driver.remark.trim()}</div>
                    ) : null}
                  </div>
                </div>
                {tel ? (
                  <a
                    href={`tel:${tel}`}
                    className="w-10 h-10 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
                    style={{ background: "#2563EB" }}
                    aria-label="拨打司机电话"
                  >
                    <i className="ri-phone-line text-white" style={{ fontSize: 16 }} />
                  </a>
                ) : null}
              </div>
            </div>
          )}
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap"
            style={{ background: "#F4F5F9", color: "#6B7280" }}
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  );
}
